import React from 'react';
import  '../styles/HomePage.css'
import {useHistory} from "react-router-dom";

export const Header =() =>{
    const history = useHistory();

    const handleOnClick =() => {
        history.push('/researcher');
    }
    return (
        <div className='header'>
            <h3 className='app-name'>Research</h3>
            <div className='researcher-link' onClick={handleOnClick}>Are you a researcher?</div>
        </div>
    );
}